import { h, Host, } from '@stencil/core';
import cn from 'classnames';
import { ETabType, scrollToComponent } from '@pes-ui/utils';
import { isMobile } from '../../../globals/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
export class Specifications {
  handleToggleViewMore(e) {
    this.isExpanded = e.detail;
    if (!(this.isExpanded && this.showViewMoreLabel)) {
      this.specificationsRef.scrollIntoView(true);
    }
  }
  hasCharacteristics() {
    var _a;
    return Boolean((_a = this.characteristicTables) === null || _a === void 0 ? void 0 : _a.length);
  }
  handleTabClicked(event) {
    if (this.specificationsRef && event.detail.type === ETabType.SPECIFICATIONS) {
      scrollToComponent(this.specificationsRef);
    }
  }
  observe() {
    observeIntersectionWithHeader(this.specificationsRef, (entries) => {
      var _a;
      if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
        setTabActive({ type: ETabType.SPECIFICATIONS, title: this.productCharacteristicsLabel });
        this.setTabActive.emit();
      }
    });
  }
  constructor() {
    this.showViewMore = () => {
      var _a, _b;
      const wrapperHeight = (_a = this.specificationsRef.shadowRoot
        .querySelector('.specifications__view-more-content-wrapper')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
      const contentHeight = (_b = this.specificationsRef.shadowRoot
        .querySelector('.specifications__view-more-content')) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height;
      return contentHeight > wrapperHeight;
    };
    this.renderViewMore = () => {
      return (this.showViewMoreLabel && (h("div", { class: "specifications__view-more-wrapper" }, h("pes-view-more-link", { viewMoreLabel: this.showMoreLabel, viewLessLabel: this.showLessLabel, isExpanded: this.isExpanded }))));
    };
    this.renderSpecifications = () => {
      var _a;
      const isMinimized = this.showViewMoreLabel && !this.isExpanded;
      return (h("div", { class: cn('specifications', 'specifications__view-more-content-wrapper', this.isExpanded && 'specifications__view-more-content-wrapper--expanded') }, h("div", { class: cn('specifications__view-more-content', isMinimized && 'specifications__view-more-content--minimized') }, (_a = this.characteristicTables) === null || _a === void 0 ? void 0 : _a.map((table) => {
        var _a, _b, _c;
        const isMainCategory = ((_a = this.runtimeInfo) === null || _a === void 0 ? void 0 : _a.mainCategory) === table.tableName;
        const runtimeInfo = isMainCategory
          && ((_b = this.runtimeInfo) === null || _b === void 0 ? void 0 : _b.product) && ((_c = this.runtimeInfo) === null || _c === void 0 ? void 0 : _c.translations)
          ? this.runtimeInfo
          : undefined;
        return h("pes-specifications-table", { data: table, runtimeInfo: runtimeInfo });
      }))));
    };
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.runtimeInfo = undefined;
    this.characteristicTables = undefined;
    this.productCharacteristicsLabel = undefined;
    this.showMoreLabel = undefined;
    this.showLessLabel = undefined;
    this.showViewMoreLabel = false;
    this.isExpanded = false;
    this.isMobile = isMobile();
    this.specificationsRef.dir = document.documentElement.dir || 'auto';
  }
  initializestickyBarTab() {
    setStickyBarTab(ETabType.SPECIFICATIONS, [this.productCharacteristicsLabel]);
    this.observe();
  }
  connectedCallback() {
    window.addEventListener('resize', this.resizeWindow);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  componentWillRender() {
    this.initializestickyBarTab();
  }
  componentDidLoad() {
    if (this.specificationsRef) {
      setTimeout(() => {
        this.showViewMoreLabel = this.showViewMore();
      }, 1000);
    }
    if (this.hasCharacteristics()) {
      this.initializestickyBarTab();
    }
  }
  renderMobileView() {
    return (h("pes-collapsible-container", { class: "specifications__collapsible-container" }, h("pes-section-header", { slot: "header", class: "specifications__heading" }, this.productCharacteristicsLabel), h("div", { class: "specifications__content" }, this.renderSpecifications(), this.renderViewMore())));
  }
  renderDesktopView() {
    return (h("pes-section-with-header", { id: "pes-section-with-header", headingLabel: this.productCharacteristicsLabel, withColumns: true }, this.renderSpecifications(), this.renderViewMore()));
  }
  render() {
    if (this.hasCharacteristics()) {
      return (h(Host, null, this.isMobile && this.renderMobileView(), !this.isMobile && this.renderDesktopView()));
    }
  }
  static get is() { return "pes-specifications"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["specifications.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["specifications.css"]
    };
  }
  static get properties() {
    return {
      "runtimeInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeInfo",
          "resolved": "{ product: { id: string; } & TRuntimeAttributes; mainCategory: string; translations: TRuntimeTranslations; }",
          "references": {
            "TRuntimeInfo": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "characteristicTables": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSpecificationTable[]",
          "resolved": "TSpecificationTable[]",
          "references": {
            "TSpecificationTable": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productCharacteristicsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-characteristics-label",
        "reflect": false
      },
      "showMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-more-label",
        "reflect": false
      },
      "showLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-less-label",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "showViewMoreLabel": {},
      "isExpanded": {},
      "isMobile": {}
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "specificationsRef"; }
  static get listeners() {
    return [{
        "name": "didToggleViewMore",
        "method": "handleToggleViewMore",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
